// app/features/staff_access/services_and_hooks/staffAccessService.ts

import {
  apiDelete,
  apiGet,
  apiPatch,
  apiPost,
} from "@/app/shared/utils/api-helpers";

import type {
  InviteStaffAccessInput,
  StaffAccessUser,
  UpdateStaffAccessInput,
} from "../staff_access.interfaces";

const API_BASE = "/api/admin/staff-access";

export async function fetchMyStaffAccess(): Promise<StaffAccessUser | null> {
  const res = await apiGet<{ access: StaffAccessUser | null }>(
    `${API_BASE}/me`,
  );
  if (!res.success) {
    throw new Error(res.error || "Failed to load staff access");
  }
  return res.data?.access ?? null;
}

export async function listStaffAccessUsers(): Promise<StaffAccessUser[]> {
  const res = await apiGet<{ users: StaffAccessUser[] }>(API_BASE);
  if (!res.success || !res.data?.users) {
    throw new Error(res.error || "Failed to list staff users");
  }
  return res.data.users;
}

export async function inviteStaffAccessUser(
  input: InviteStaffAccessInput,
): Promise<StaffAccessUser> {
  const res = await apiPost<{ user: StaffAccessUser }>(API_BASE, input);
  if (!res.success || !res.data?.user) {
    throw new Error(res.error || "Failed to invite user");
  }
  return res.data.user;
}

export async function updateStaffAccessUser(
  input: UpdateStaffAccessInput,
): Promise<StaffAccessUser> {
  const { id, ...body } = input;
  const res = await apiPatch<{ user: StaffAccessUser }>(
    `${API_BASE}/${id}`,
    body,
  );
  if (!res.success || !res.data?.user) {
    throw new Error(res.error || "Failed to update user");
  }
  return res.data.user;
}

export async function disableStaffAccessUser(
  id: string,
): Promise<StaffAccessUser> {
  const res = await apiDelete<{ user: StaffAccessUser }>(`${API_BASE}/${id}`);
  if (!res.success || !res.data?.user) {
    throw new Error(res.error || "Failed to disable user");
  }
  return res.data.user;
}
